/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturMercuryIcon16Solid = forwardRef('KonturMercuryIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.32 10.008a2.266 2.266 0 1 1 4.533 0 2.266 2.266 0 0 1-4.533 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.739.886C9.888.202 9.081-.277 8.552.18L1.77 6.037a.73.73 0 0 0-.077.077 5.508 5.508 0 1 0 8.015 7.537.728.728 0 0 0 .046-.05l6.065-7.139c.443-.522-.014-1.312-.688-1.187l-3.18.59 2.289-4.199c.359-.657-.39-1.363-1.025-.966L9.239 3.185l.5-2.3ZM5.586 6.414a3.593 3.593 0 1 0 0 7.187 3.593 3.593 0 0 0 0-7.187Z" })));
});
